<template>
  <v-card class="group-info-layout px-2">
      <v-card-title class="font-weight-bold">
        {{ isShowSelect ? (!orgData.orgNm ? "" : orgData.orgNm)+"팀" : "삭제현황" }}
      </v-card-title>
      <v-tabs v-model="tabs" v-if="isShowSelect">
        <v-tab>부서 정보</v-tab>
        <v-tab>부서원 목록</v-tab>
        <v-tab-item>
          <v-divider class="mt-1"></v-divider>
          <org-data-info
            :org-data="orgData"
            @refresh="$emit('refresh')"
          />
        </v-tab-item>
        <v-tab-item>
          <v-divider class="mt-1"></v-divider>
          <org-member-list
            :selected-data="selectedData"
            @refresh="$emit('refresh')"
          />
        </v-tab-item>
      </v-tabs>
      <v-tabs v-model="deleteTabs" v-else-if="isShowDelete">
        <v-tab>조직목록</v-tab>
        <v-tab>회원목록</v-tab>
        <v-tab-item>
          <v-divider class="mt-1"></v-divider>
          <delete-org-list :delete-tabs="deleteTabs" @refresh="$emit('refresh')" />
        </v-tab-item>
        <v-tab-item>
          <v-divider class="mt-1"></v-divider>
          <delete-member-list :delete-tabs="deleteTabs" @refresh="$emit('refresh')" />
        </v-tab-item>
      </v-tabs>
  </v-card>
</template>
<script>
import OrgDataInfo from "@/pages/Member/components/MemberManage/OrgDataInfo.vue";
import OrgMemberList from "@/pages/Member/components/MemberManage/OrgMemberList.vue";
import DeleteOrgList from "@/pages/Member/components/MemberManage/DeleteOrgList.vue";
import DeleteMemberList from "@/pages/Member/components/MemberManage/DeleteMemberList.vue";
import {axiosInstance} from "@/util/AxiosModule";
import _ from "lodash";

export default {
  name: "OrganizationInfo",
  components: {DeleteMemberList, DeleteOrgList, OrgMemberList, OrgDataInfo},
  props: ["isShowSelect", "isShowDelete", "selectedData"],
  data() {
    return {
      tabs: [0, 1],
      deleteTabs: [2, 3],
      orgData: {},

    }
  },
  mounted() {
    this.tabs = 0;
  },
  watch: {
    selectedData(newValue, oldValue) {
      if (newValue.type === "ORG") {
        this.tabs = 0;
        // this.getOrgData();
      } else {
        this.tabs = 1;
      }
      if (newValue !== oldValue) {
        this.getOrgData();
      }
    }
  },
  methods: {
    async getOrgData() {
      const orgCd = this.selectedData.type === "ORG"
          ? this.selectedData.id
          : this.selectedData.upperOrgCd;

      try {
        const { data } = await axiosInstance.get("/private/org/org", {
          params: {
            orgCd: orgCd
          }
        });
        if (_.isEmpty(data)) {
          this.orgData = {};
        } else {
          this.orgData = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.group-info-layout {
  margin: 10px;
  width: 75vw;
}
</style>